export function UUID() {
    let uuidValue: string = '';
    let k: number;
    let randomValue: number;
    for (k = 0; k < 32; k++) {
        randomValue = Math.random() * 16 | 0;

        if (k === 8 || k === 12 || k === 16 || k === 20) {
            uuidValue += '-';
        }
        if (k === 12) {
            uuidValue += '4';
        } else if (k === 16) {
            uuidValue += (randomValue & 3 | 8).toString(16);
        } else {
            uuidValue += randomValue.toString(16);
        }
    }
    return uuidValue;
}

/**
 * Convert a Base64/URL-safe 16-byte payload to canonical UUID text.
 */
export function Base64ToUUID(b64: string): string {
    // normalize to padded standard Base64
    const std = b64.replace(/-/g, '+').replace(/_/g, '/').
        padEnd(Math.ceil(b64.length / 4) * 4, '=');

    // decode to raw bytes (browser)
    const bin = atob(std);                       // binary string, 1 char = 1 byte
    if (bin.length !== 16) {
        throw new Error(`expected 16 decoded bytes, got ${bin.length}`);
    }
    const hex: string[] = [];
    for (let i = 0; i < 16; ++i) {
        hex.push(bin.charCodeAt(i).toString(16).padStart(2, '0'));
    }
    const s = hex.join('');
    return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`;
}
